import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
export default class PrivateRoute extends React.Component {
  render() {
    const { userStore, ...restProps } = this.props;
    if (userStore.IsLoggedIn()) {
      return <Route {...restProps} />;
    }
    else {
      return <Redirect to="/Login" />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js